// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPaginationSmallLeft = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16">
            <polygon
                fill="currentColor"
                points="1.655 28 2.291 28.802 7.51 35.383 8 36 7.51 36.617 1.655 44 0 42.766 .636 41.963 5.366 36 .636 30.037 0 29.234"
                transform="matrix(-1 0 0 1 8 -28)"
            />
        </svg>
    );
};

export default React.memo(IconPaginationSmallLeft);
